import CifraBankIcon from './cifra-bank.svg?react'
import CifraBankLightIcon from './cifra-bank-light.svg?react'
import ArrowLeft from './arrow-left.svg?react'
import ArrowRight from './arrow-right.svg?react'
import ArrowDown from './arrow-down.svg?react'
import Menu from './menu.svg?react'
import Close from './close.svg?react'
import Logout from './logout.svg?react'
import Check from './check.svg?react'
import Arrow45 from './arrow-45.svg?react'
import Alert from './alert.svg?react'
import Info from './info.svg?react'
import Link from './link.svg?react'
import Calendar from './calendar.svg?react'
import ThemeMode from './theme-mode.svg?react'
import Profile from './profile.svg?react'
import ArrowBack from './arrow-back.svg?react'
import Copy from './copy.svg?react'
import CheckedRB from './checked-rb.svg?react'
import RadioButton from './rb.svg?react'
import Add from './add.svg?react'
import Trash from './trash.svg?react'
import Edit from './edit.svg?react'
import Share from './x24-share.svg?react'
import Telegram from './icon_x24_telegram.svg?react'
import Bill from './icon_x24_bill.svg?react'
import Mail from './icon_x24_mail.svg?react'
import MaxLogo from './max.svg?react'
import Attach from './attach.svg?react'
import Cross from './cross.svg?react'
import Document from './document.svg?react'
import Warning from './warning.svg?react'
import Settings from './settings.svg?react'
import DragPlace from './drag-place.svg?react'
import C2BOperation from './c2b-operation.svg?react'
import B2BOperation from './b2b-operation.svg?react'
import B2COperation from './b2c-operation.svg?react'
import AcqOperation from './acq-operation.svg?react'
import SbpOperation from './sbp-operation.svg?react'
import OneTimePaymentPage from './one-time-payment-page.svg?react'
import StaticPaymentPage from './static-payment-page.svg?react'

export const Icons = {
  Add,
  Telegram,
  Bill,
  Mail,
  Trash,
  Share,
  Edit,
  CheckedRB,
  RadioButton,
  Alert,
  Info,
  Copy,
  ArrowBack,
  ThemeMode,
  Link,
  Calendar,
  Arrow45,
  ArrowDown,
  ArrowLeft,
  Profile,
  ArrowRight,
  Check,
  CifraBankIcon,
  CifraBankLightIcon,
  Close,
  Logout,
  Menu,
  Attach,
  Cross,
  Document,
  Warning,
  Settings,
  DragPlace,
  C2BOperation,
  B2BOperation,
  B2COperation,
  AcqOperation,
  SbpOperation,
  OneTimePaymentPage,
  StaticPaymentPage,
}

export { MaxLogo }
export type IconName = keyof typeof Icons
